import { SdkConsts } from '../consts.js';
import { ContextClassBase } from '../service/RuntimeContext.js';

var MonitorItem;
(function (MonitorItem) {
    // Unified indicator
    MonitorItem["CreateConversation"] = "create.conv";
    MonitorItem["SendMessage"] = "send.msg";
    MonitorItem["ReceiveMessage"] = "recieve.msg";
    MonitorItem["WsConnect"] = "ws.connect";
    MonitorItem["NetworkRequest"] = "network.request";
    // ws
    MonitorItem["FrontierOpen"] = "frontier.open";
    MonitorItem["FrontierClose"] = "frontier.close";
    MonitorItem["FrontierError"] = "frontier.error";
    MonitorItem["FrontierReceive"] = "frontier.receive";
    MonitorItem["FrontierLive"] = "frontier.live";
    MonitorItem["WebSocketConnectFirst"] = "ws.connect.first";
    MonitorItem["WebSocketConnectAfterClose"] = "ws.connect.afterclose";
    MonitorItem["WebSocketConnectNoHeartbeat"] = "ws.connect.noheartbeat";
    // network
    MonitorItem["BizApiInvoke"] = "api.invoke";
    MonitorItem["MessageAck"] = "message.ack";
    MonitorItem["SuccessSuffix"] = ".success";
    MonitorItem["ErrorSuffix"] = ".error";
    // other
    MonitorItem["BizSdkInit"] = "init";
    MonitorItem["BizRefreshToken"] = "refresh.token";
    MonitorItem["BizSdkError"] = "error";
    MonitorItem["GetMessagesByConversation"] = "message.get.byconversation";
    MonitorItem["GetMessagesByTicker"] = "message.get.ticker";
})(MonitorItem || (MonitorItem = {}));
class Monitor extends ContextClassBase {
    static get avgDelta() {
        if (this.putDeltaTimes === 0) {
            return 0;
        }
        return this.totalDelta / this.putDeltaTimes;
    }
    static putTimeDelta(clientRequestStart, clientRequestEnd, serverExecutionEndTime, requestArrivedTime) {
        if (serverExecutionEndTime === undefined || requestArrivedTime === undefined) {
            return;
        }
        const requestDuration = clientRequestEnd - clientRequestStart;
        const serverExecutionDuration = serverExecutionEndTime - requestArrivedTime;
        const estimateRequestArrivedTime = (requestDuration - serverExecutionDuration) / 2 + clientRequestStart;
        const delta = requestArrivedTime - estimateRequestArrivedTime;
        Monitor.putDeltaTimes++;
        Monitor.totalDelta += delta;
    }
    get avgDelta() {
        return Monitor.avgDelta;
    }
    static performanceNow() {
        if (typeof performance === 'object' &&
            typeof performance.now === 'function' &&
            typeof performance.timeOrigin === 'number') {
            return performance.now() + performance.timeOrigin;
        }
        else {
            return Date.now();
        }
    }
    invoke(funcName, ...args) {
        if (this.ctx.option.monitor === undefined) {
            return false;
        }
        let mon = this.ctx.option.monitor;
        if (!Array.isArray(mon)) {
            mon = [mon];
        }
        mon.forEach(inst => {
            // @ts-ignore
            const func = inst[funcName];
            if (typeof func !== 'function') {
                return false;
            }
            return setTimeout(() => {
                func.apply(inst, args);
            }, 0);
        });
    }
    fillKv(tagKv) {
        const newKv = Object.assign(Object.assign(Object.assign({}, tagKv), this.ctx.option.monitorTagKv), { sdk_version: SdkConsts.sdkVersion, sdk_type: 'im-web-sdk', build_number: SdkConsts.buildNumber, app_id: this.ctx.option.appId.toString(), user_id: this.ctx.option.userId });
        if (this.ctx.option.versionCode) {
            newKv.version_code = this.ctx.option.versionCode;
        }
        return newKv;
    }
    emitMetrics(name, metrics = {}, tagKv = {}) {
        const key = `imsdk.${name}`;
        this.invoke('emitMetrics', key, metrics, this.fillKv(tagKv));
    }
    emitCounter(name, count = 1, tagKv = {}) {
        if (count === 0) {
            return;
        }
        const key = `imsdk.${name}`;
        this.invoke('emitMetrics', key, { count }, this.fillKv(tagKv));
    }
    emitDuration(name, start, tagKv = {}) {
        const current = Monitor.performanceNow();
        const duration = current - start;
        const key = `imsdk.${name}`;
        this.invoke('emitMetrics', key, { duration }, this.fillKv(tagKv));
        return duration;
    }
    // use absolute time
    emitLatencyDuration(key, start, tagKv = {}) {
        const timeDelta = this.ctx.option.timeCalibration ? this.avgDelta : 0;
        const current = Monitor.performanceNow();
        const duration = current + timeDelta - start;
        // skip invalid duration
        if (duration < 0) {
            return;
        }
        this.invoke('emitMetrics', key, { duration }, this.fillKv(tagKv));
    }
    emitError(error) {
        this.invoke('emitError', error, this.fillKv({}));
    }
    emitNetwork(req, resp, tagKv = {}) {
        this.invoke('emitNetwork', req, resp, this.fillKv(tagKv));
    }
    emitEvent(event, sender, args) {
        this.invoke('emitEvent', event, sender, args);
    }
    emitLog(level, ...args) {
        this.invoke('emitLog', level, args[0]);
    }
    emitTracker(name, tagKv) {
        this.invoke('emitTracker', name, this.fillKv(tagKv));
    }
}
// 校时逻辑
// ref: wikcn8NYDc2vjEVhU02b7Us3Epd
Monitor.putDeltaTimes = 0;
Monitor.totalDelta = 0;

export { Monitor, MonitorItem };
//# sourceMappingURL=monitor.js.map
